<div class="offer-item {{theme}}" *ngIf="vehicle" [ngClass]="{'active': showDetail}">
  <div class="item-header" (click)="toggleDetail()" [ngClass]="{'accepted': vehicle.status == 'ACCEPTED'}">
    <div class="row">
      <div class="col-md-12">
        <div class="price">
          <span class="currency">R$</span>
          <span class="value">{{value | number}}</span>
        </div>
        <div class="historic-time">
          {{vehicle.createdAt | relativetimePT }}
          <span *ngIf="animationState == 'out'">por {{vehicle.dealerName}}</span>
        </div>
        <div class="rejected-offer" *ngIf="vehicle.status === 'REJECTED'">Oferta rejeitada</div>
        <div class="accepted-offer" *ngIf="vehicle.status === 'ACCEPTED'">Oferta aceita</div>
        <div class="rejected-reason" *ngIf="vehicle.status === 'REJECTED' && vehicle.rejectionReason">
          {{vehicle.rejectionReasonMessage}}
        </div>
        <i class="material-icons" [ngClass]="{'open': animationState == 'in'}">expand_more</i>
      </div>
    </div>
  </div>
  <div class="item-body" [@slideInOut]="animationState">
    <div class="row detail">
      <div class="col-md-12">
        <div class="row">
          <div class="col-md-2">
            <i class="text-primary material-icons" role="button">person</i>
          </div>
          <div class="col-md-10">
            <div class="offer-name">
              {{vehicle.dealerName}}
            </div>
            <div class="offer-cnpj">
              CNPJ {{vehicle.dealerCpfCnpj}}
            </div>
            <div class="offer-email">
              <a target="_blank" [href]="'mailto:' + email" *ngFor="let email of vehicle.dealerEmails">{{email}}</a>
            </div>
            <div class="offer-phone">
              <span *ngFor="let number of vehicle.dealerPhoneNumbers">{{number}}</span>
            </div>
            <div class="offer-place">
              {{vehicle.dealerCity}}/{{vehicle.dealerUf}}
            </div>
          </div>
        </div>
        <div class="col-md-12 mt-3"
          *ngIf="vStatus != 'SOLD' && vStatus != 'SOLD_FAST_QUOTE' && vehicle.status !== 'REJECTED' && !showCounterOfferBox()">
          @if (canShowAcceptButton) {
          <div class="w-100" [matTooltip]="acceptDisabledTooltip" [matTooltipDisabled]="canAcceptBid">
            <button class="btn btn-primary btn-rounded btn-block" (click)="confirmBid()" [disabled]="!canAcceptBid">
              <div class="btn-spinner float-left" *ngIf="loading"></div>
              <span>
                ACEITAR PROPOSTA
              </span>
            </button>
          </div>
          }
          <div style="margin-top: 16px; width: 100%; text-align: center;">
            <button class="btn btn-outline-primary btn-rounded mb-2" (click)="loadCounterOffer()"
              *ngIf="vehicle.counterOffer === undefined || vehicle.counterOffer?.status === 'REJECTED'">
              Fazer contra proposta
            </button>
            <button class="btn btn-danger btn-rounded btn-sm" (click)="reasonToRejectBid()">
              <div class="btn-spinner" *ngIf="loadingReject"></div>
              <span>
                REJEITAR PROPOSTA
              </span>
            </button>
          </div>
        </div>
        <div class="col-md-12 mt-3" *ngIf="showCounterOfferBox()">
          <form name="counterOfferForm" (ngSubmit)="counterOfferForm.form.valid && sendCounterOffer()"
            #counterOfferForm="ngForm" class="counter-offer-form">
            <div class="title">Enviar contra proposta</div>
            <div class="row">
              <div class="col-12">
                <mat-form-field>
                  <span matPrefix class="currency-symbol">R$</span>
                  <input matInput currencyMask name="counterOfferBidValue" type="tel" [min]="minCounterOfferValue"
                    [options]="{ prefix: '', thousands: '.', precision: 0, allowNegative: false }"
                    [(ngModel)]="counterOffer.value" required #counterOfferBidValue="ngModel">

                  <mat-error *ngIf="counterOfferBidValue.errors?.required">Defina um valor para esta proposta
                  </mat-error>
                  <mat-error *ngIf="counterOfferBidValue.errors?.min">Proposta inválida. Tente novamente com um valor
                    acima de R$
                    {{minCounterOfferValue - 1 | number}}.
                  </mat-error>
                </mat-form-field>
              </div>
              <div class="col-12">
                <mat-form-field>
                  <mat-label class="mat-label">Mensagem para o comprador</mat-label>
                  <textarea matInput [(ngModel)]="counterOffer.message" name="counterOfferMessage" rows="3"></textarea>
                </mat-form-field>
              </div>
              <div class="col-md-12 warning-box" *ngIf="counterOfferErrorMessage">
                <i class="material-icons">warning</i>
                {{ counterOfferErrorMessage }}
              </div>
              <div class="col-12">
                <button class="btn btn-primary btn-rounded btn-block fs-12"
                  (click)="counterOfferForm.form.markAllAsTouched()">ENVIAR CONTRA PROPOSTA</button>
              </div>
              <div class="col-12">
                <button class="btn btn-link btn-block mt-2" (click)="closeCounterOffer()">CANCELAR</button>
              </div>
            </div>
          </form>
        </div>

        <div class="counter-offer-info" *ngIf="vehicle.counterOffer && !showCounterOfferBox()">
          <div class="counter-offer-title">Contra proposta</div>
          <div class="counter-offer-value">R$ {{vehicle.counterOffer.value | number}}</div>
          <div *ngIf="vehicle.counterOffer.message" class="counter-offer-value">{{vehicle.counterOffer.message}}</div>
          <div class="dealer-info-status"
            [ngClass]="{'rejected-status': vehicle.counterOffer.status === 'REJECTED', 'accepted-status': vehicle.counterOffer.status === 'ACCEPTED'}">
            {{getCounterOfferStatusLabel(vehicle.counterOffer.status)}}
          </div>
          <div class="dealer-info-created-at">
            Contra proposta enviada {{vehicle.counterOffer.createdAt | amTimeAgo}}
          </div>
        </div>
      </div>
    </div>
  </div>
</div>